<script lang="ts" setup>
const config = useRuntimeConfig();
const storage = useLocalStorageStore();
const user = useUserStore();
const tiles = ref<any>({});
const address = ref("")

const getAddres = async() => {
  try {
    const res = storage.getAddres();

    if(res){
      tiles.value = res.details?.tiles;
      address.value = res.details?.address
    }else{
      const response: any = await user.getInfoContact();

      if(response.status.code == 200){
        tiles.value = response.details?.tiles;
        address.value = response.details?.address
      }
    }

  } catch (error) {
    console.error(error)
  }
}

onMounted(() => {
  getAddres()
})

const getIconClass = (icon: string) => {
  switch (icon) {
    case 'f095':
      return 'fas fa-phone'
    case 'f1fa':
      return 'fas fa-envelope'
    case 'f0ac':
      return 'fas fa-globe'
    default:
      return ''
  }
}
</script>
<template>
  <footer class="text-center text-lg-start bg-light text-muted mt-4">
    <!-- Section: Social media -->
    <section
      class="container d-flex justify-content-center justify-content-lg-between p-4 border-bottom"
    >
      <!-- Left -->
      <!-- <div class="me-5 d-none d-lg-block">
        <span>Temukan sosial media kami :</span>
      </div> -->
      <!-- Left -->

      <!-- Right -->
      <!-- <div>
        <a href="/#!" class="me-4 text-reset text-decoration-none">
          <i class="fab fa-facebook-f"></i>
        </a>
        <a href="/#!" class="me-4 text-reset text-decoration-none">
          <i class="fab fa-x-twitter"></i>
        </a>
        <a href="/#!" class="me-4 text-reset text-decoration-none">
          <i class="fab fa-instagram"></i>
        </a>
      </div> -->
      <!-- Right -->
    </section>
    <!-- Section: Social media -->

    <!-- Section: Links  -->
    <section class="">
      <div class="container text-center text-md-start mt-5">
        <!-- Grid row -->
        <div class="row mt-3">
          <!-- Grid column -->
          <div class="col-md-3 col-lg-4 col-xl-3 mx-auto mb-4">
            <!-- Content -->
            <img 
              class="img-fluid w-100 px-3"
              :src="`${config.public.logo}`"
              alt="logo"
            />
            <div class="mt-4">&nbsp;</div>
            <!-- <h6 class="text-center text-uppercase fw-bold mb-4 mt-4">Download {{ config.public.systemName }} App</h6>
            <div class="d-flex justify-content-between">
              <figure><NuxtLink :to="`https://play.google.com/store/apps/details?id=com.app.${config.public.systemName}&pcampaignid=web_share`" target="_blank"><img  src="/images/get_in_on_gplay.png" style="max-width: 8rem;" title="Our Android Apps"></NuxtLink></figure>
              <figure><NuxtLink :to="`https://play.google.com/store/apps/details?id=com.app.${config.public.systemName}&pcampaignid=web_share`" target="_blank"><img  src="/images/get_in_on_appstore.png" style="max-width: 8rem;" title="Our iOs Apps"></NuxtLink></figure>
            </div> -->
          </div>
          <!-- Grid column -->

          <!-- Grid column -->
          <div class="col-md-2 col-lg-2 col-xl-2 mx-auto mb-4">
            <!-- Links -->
            <h6 class="text-uppercase fw-bold mb-4">Tentang Kami</h6>
            <figure>
              <NuxtLink to="/contact-us" class="text-reset text-decoration-none">Pusat Bantuan</NuxtLink>
            </figure>
            <figure>
              <NuxtLink to="/privacy-policy" class="text-reset text-decoration-none">Privasi Policy</NuxtLink>
            </figure>
            <figure>
              <NuxtLink to="/term-payments" class="text-reset text-decoration-none" >Payment Policy</NuxtLink>
            </figure>
            <figure>
              <NuxtLink to="/policy" class="text-reset text-decoration-none" >Syarat & Ketentuan</NuxtLink>
            </figure>
          </div>
          <!-- Grid column -->

          <!-- Grid column -->
          <div class="col-md-3 col-lg-2 col-xl-2 mx-auto mb-4">
            <!-- Links -->
            <h6 class="text-uppercase fw-bold mb-4">Produk</h6>
            <figure>
              <NuxtLink to="/airlines/" class="text-reset text-decoration-none">Tiket Pesawat</NuxtLink>
            </figure>
            <figure>
              <NuxtLink to="/trains" class="text-reset text-decoration-none">Tiket Kereta Api</NuxtLink>
            </figure>
            <figure>
              <NuxtLink to="/pelni" class="text-reset text-decoration-none">Tiket Pelni</NuxtLink>
            </figure>
            <figure>
              <NuxtLink to="/hotels" class="text-reset text-decoration-none">Hotel</NuxtLink>
            </figure>
            <figure>
              <NuxtLink to="/ppob" class="text-reset text-decoration-none">Pulsa dan Tagihan</NuxtLink>
            </figure>
          </div>
          <!-- Grid column -->

          <!-- Grid column -->
          <div class="col-md-4 col-lg-3 col-xl-3 mx-auto mb-md-0 mb-4">
            <!-- Links -->
            <h6 class="text-uppercase fw-bold mb-4">Hubungi Kami</h6>
            <figure>
              <i class="fas fa-home me-3"></i>
              {{ address }}
            </figure>
            <figure v-for="tile in tiles">
              <i :class="getIconClass(tile.icon)" class="me-3"></i> {{ tile.value }}
            </figure>
            <!-- <figure>
              <i class="fas fa-envelope me-3"></i>
              group@atacorp.co
            </figure>
            <figure><i class="fas fa-phone me-3"></i> (021) 29117120</figure> <br /> -->
          </div>
          <!-- Grid column -->
        </div>
        <!-- Grid row -->
      </div>
    </section>
    <!-- Section: Links  -->

    <!-- Copyright -->
    <div class="text-center p-4 bg-terytari">
      Copyright © 2025
      <a href="/" class="text-decoration-none fw-semibold text-black"
        >{{ config.public.systemName }}.</a>
      All Right Reserved
    </div>
    <!-- Copyright -->
  </footer>
</template>